import { createFileRoute } from '@tanstack/react-router';

import { NicheConfigPage } from '../modules/location-niche-config/ui/pages/NicheConfigPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as tariff + zones + assignments routes).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/niche-config/',
)({
  component: NicheConfigPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Niche Template'],
  },
});
